import React from "react";

import { useRecoilState } from "recoil";
import { onboardingState } from "../../../store/onboardingState";

import RadioForm from "../../molecules/onboarding/radioForm";

const Step03 = ({ style }) => {
  const [onboardingStateAtom, setOnboardingStateAtom] =
    useRecoilState(onboardingState);

  const questionList07 = [
    {
      title: "전혀 없음",
      value: "지식,부동산 기초",
    },
    {
      title: "1~2회",
      value: "지식,실전,부동산 기초,대출 기초",
    },
    {
      title: "3회~10회",
      value: "실전,부동산 중급,재테크 중급,경제 기초",
    },
    {
      title: "10회 초과",
      value: "실전,부동산 중급,재테크 중급",
    },
  ];
  const questionList08 = [
    {
      title: "0채",
      value: "지식,대출 기초,재테크 기초,부동산 기초,경제 기초",
    },
    {
      title: "1채",
      value: "실전,대출 기초,대출 중급,부동산 기초,부동산 중급,경제 기초",
    },
    {
      title: "2채 이상",
      value: "실전,대출 기초,대출 중급,부동산 중급",
    },
    {
      title: "2채 이상 + @",
      value: "실전,대출 중급,부동산 중급",
    },
  ];
  const questionList09 = [
    {
      title: "아파트 또는 빌라",
      value: "지식,실전,대출 기초,부동산 기초",
    },
    {
      title: "오피스텔, 지식산업센터",
      value: "실전,대출 중급",
    },
    {
      title: "상가",
      value: "실전,대출 중급",
    },
    {
      title: "토지",
      value: "실전,대출 중급",
    },
  ];
  const questionList10 = [
    {
      title: "전혀 모름",
      value: "지식,부동산 기초,대출 기초",
    },
    {
      title: "뜻만 알고 있음",
      value: "지식,부동산 기초,대출 기초",
    },
    {
      title: "계산해 본 적 있음",
      value: "실전,부동산 기초,부동산 중급",
    },
    {
      title: "자유롭게 계산이 가능함",
      value: "실전,부동산 중급",
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        ...style,
      }}
    >
      <RadioForm
        questionList={questionList07}
        questionValue={onboardingStateAtom.question07}
        questionKey={"question07"}
        numbering={"07."}
        title={"임장 경험 또는 부동산 중개인과 상담 경험이 어떻게 되나요?"}
      />

      <RadioForm
        style={{
          marginTop: 60,
        }}
        questionList={questionList08}
        questionValue={onboardingStateAtom.question08}
        questionKey={"question08"}
        numbering={"08."}
        title={"현재 보유한 주택의 갯수는?"}
      />

      <RadioForm
        style={{
          marginTop: 60,
        }}
        questionList={questionList09}
        questionValue={onboardingStateAtom.question09}
        questionKey={"question09"}
        numbering={"09."}
        title={"현재 가장 관심 있는 투자 목적의 부동산 종류는?"}
      />

      <RadioForm
        style={{
          marginTop: 60,
        }}
        questionList={questionList10}
        questionValue={onboardingStateAtom.question10}
        questionKey={"question10"}
        numbering={"10."}
        title={"LTV,DTI,DSR에 대한 이해 정도는 어떠한가요?"}
        radioStyle={{
          flexDirection: "column",
        }}
      />
    </div>
  );
};

export default Step03;
